import {Component, Inject, NgZone, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AuthService} from "../../services/auth.service";
import {BehaviorSubject, interval, ReplaySubject, Subscription} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Profile} from "../../interface/profile";
import {LoginLockTimerComponent} from "../login-lock-timer/login-lock-timer.component";
import {co} from "@fullcalendar/core/internal-common";
import {UserService} from "../../services/user.service";

export interface LoginLockDialogData {
  startAt: string;
  endAt: string;
  loginLock: string;
}

@Component({
  selector: 'app-login-lock-dialog',
  templateUrl: './login-lock-dialog.component.html',
  styleUrls: ['./login-lock-dialog.component.scss']
})
export class LoginLockDialogComponent implements OnDestroy, OnInit {
  startAt = '';
  endAt = '';
  loginLock = '';

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private countdownSub?: Subscription;
  public countdown$ = new BehaviorSubject<string>('...');

  constructor(
    public dialogRef: MatDialogRef<LoginLockDialogComponent>,
    private authService: AuthService,
    private userService: UserService,
  @Inject(MAT_DIALOG_DATA) public data: LoginLockDialogData
  ) {
    this.startAt = data.startAt;
    this.endAt = data.endAt;
    this.loginLock = data.loginLock;
    // this.authService.loadProfile();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.startCountdown();
    this.userService.sendLoginLock().subscribe();
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  decline(): void {
    this.dialogRef.close(false);
  }

  startCountdown(): void {
    let validUntilStr = this.loginLock;



    validUntilStr = validUntilStr.replace(' ', 'T');


    if (!validUntilStr.endsWith('Z') && !validUntilStr.includes('+')) {
      validUntilStr += 'Z';
    }

    const validUntil = new Date(validUntilStr).getTime();

    this.countdownSub?.unsubscribe();

    this.countdownSub = interval(1).subscribe(() => {
      const now = Date.now();
      const diff = validUntil - now;

      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      this.countdown$.next(
        `${this.pad(minutes)}:${this.pad(seconds)}`
      );
      if (this.countdown$.getValue() === '00:00') {
        this.dialogRef.close();
      }
    });
  }

  private pad(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
}
